<template>
  <fa-icon
    v-if="platform === StrapiPlatform.Pc"
    :icon="faDesktop"
    class="size-4"
  />
  <fa-icon
    v-else-if="platform === StrapiPlatform.XBox"
    :icon="faXbox"
    class="size-4"
  />
  <fa-icon
    v-else-if="platform === StrapiPlatform.Ps4"
    :icon="faPlaystation"
    class="size-4"
  />
  <span v-else>{{ platform }}</span>
</template>

<script setup lang="ts">
import { faDesktop } from '@fortawesome/pro-solid-svg-icons';
import { faXbox, faPlaystation } from '@fortawesome/free-brands-svg-icons';
import { StrapiPlatform } from '~/apollo/types/types';

defineProps<{
  platform: StrapiPlatform;
}>();
</script>
